module.exports = __webpack_public_path__ + "img/2.df99d662.jpg";